import BatteryModal from './battery-modal';

export default BatteryModal;
